import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';

function SaldoDinero() {
  const { user } = useContext(AuthContext);
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;


  useMemo(() => {
    axios
    .get(`${URL_ABONOS}SaldoDinero`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let movimientos = response.data;
      let dataFinal = movimientos.map((m) => {

  return {
    fecha: m.fecha,
    movimiento: m.movimiento,
    observaciones: m.observaciones,
    numero: m.numero,
    abono: m.abono,
    cargo: m.cargo,
    // saldo: saldoAcumulado.toLocaleString("en-US", { style: "currency", currency: "USD" }),
  };
      });
  
      setComments(dataFinal);   // tabla limpia
    })
  
  .catch((err) => {
    console.error("Error al obtener movimientos:", err);
  })
      .catch((err) => {
        console.log(err);
      });
     
      // let SI = movimientos.map((c)=>{
      //   if(selectedFechaInicio){
      //     if(
      //     (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)){
      //       return (
      //           c.cargo - c.abono
      //       )
      //     }
      //   }
      //   else{
      //     return 0
      //   }
      // }).filter(function (el) {
      //   return el != null;
      // });

      // let TC = SI.reduce((t, total, index) => t + total, 0);

      // setSaldoInicial(TC)

  }, [user]);

console.log("hola", comments)
  const ListaClientes = comments.sort((a, b) =>
    a.fecha > b.fecha ? 1 : -1
  );

  function PDFTabla() {
    let saldoParcial = 0;
    const data = comments.map((a) => { {
      saldoParcial = saldoParcial - a.cargo + a.abono;
        return [
          a.fecha,
          a.numero,
          a.movimiento,
          a.observaciones,
          "$" + new Intl.NumberFormat("en-US").format(a.cargo),
          "$" + new Intl.NumberFormat("en-US").format(a.abono),
          "$" + new Intl.NumberFormat("en-US").format(saldoParcial),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Saldo Dinero`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Número", "Movimiento", "Observaciones", "Pagos", "Abonos", "Saldo"]],
      body: dataPDFLimpia,
      startY: 45,
      // foot: [
      //   [
      //     "Totales",
      //     "$" + new Intl.NumberFormat("en-US").format(totalCargos),
      //     "$" + new Intl.NumberFormat("en-US").format(totalAbonos),
      //     "$" + new Intl.NumberFormat("en-US").format(totalSaldo),
      //   ],
      // ],
      showFoot: "lastPage",
    });
    doc.save(`SaldoDinero.pdf`);
  }

  function excel() {
    let saldoParcial = 0;
    const dataExcel = comments.map((a) => { {
      saldoParcial = saldoParcial - a.cargo + a.abono;
        return {
          Fecha: a.fecha,
          Numero: a.numero,
          Movimiento: a.movimiento,
          Observaciones: a.observaciones,
          Pagos: a.cargo,
          Abonos: a.abono,
          Saldo: saldoParcial
      }}
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "SaldoDinero";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "SaldoDinero",
        sheetFilter: ["Fecha", "Numero", "Movimiento", "Observaciones", "Pagos", "Abonos", "Saldo"],
        sheetHeader: ["Fecha", "Numero", "Movimiento", "Observaciones", "Pagos", "Abonos", "Saldo"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  // function enviaMail() {
  //   const data = ListaClientes.map((a) => {
  //     if (
  //       (activo == 0 || activo == a.is_active)
  //     ) {
  //       return [
  //         a.nombre_comercial,
  //         "$" + new Intl.NumberFormat("en-US").format(a.cargos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.abonos),
  //         "$" + new Intl.NumberFormat("en-US").format(a.saldo),
  //       ];
  //     }
  //   });
  //   const dataPDF = Object.values(data);
  //   const dataPDFLimpia = dataPDF.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 140, 15, 25, 25);
  //   doc.text(`Saldo Dinero`, 20, 40);
  //   doc.autoTable({
  //     head: [["Cliente","Cargos", "Abonos", "Saldo"]],
  //     body: dataPDFLimpia,
  //     startY: 45,
  //     foot: [
  //       [
  //         "Totales",
  //         "$" + new Intl.NumberFormat("en-US").format(totalCargos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalAbonos),
  //         "$" + new Intl.NumberFormat("en-US").format(totalSaldo),
  //       ],
  //     ],
  //     showFoot: "lastPage",
  //   });
  //   var att = doc.output("arraybuffer");
  //   var base64File = encode.encode(att, "base64");

  //   // Envia el Mail
  //   axios
  //     .post(
  //       URL_SEND_MAIL_ATT,
  //       {
  //         subject: "Saldo Dinero",
  //         email: mailTo,
  //         fileName: "SaldoDinero.pdf",
  //         att: base64File,
  //         text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
  //        <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
  //        <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
  //        <tbody>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
  //        <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los clientes.</tr>
  //        </tbody>
  //        <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
  //        <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
  //        </table>`,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       toggleMail();
  //       Swal.fire("Good job!", "Enviado con exito", "success");
  //       setMailTo("")
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //       });
  //       console.log(error);
  //     });
  // }



  const headers = [
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Numero", field: "numero", sortable: false },
    { name: "Movimiento", field: "movimiento", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: false },
    { name: "Pagos", field: "cargo", sortable: false },
    { name: "Abonos", field: "abono", sortable: false },
    { name: "Saldo", field: "saldoParcialTabla", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.movimiento.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.cargo.toString().includes(search)||
          comment.abono.toString().includes(search)||
          comment.saldo.toString().includes(search)
      );
    }
    setTotalItems(computedComments.length);

//Sorting comments
if (
  sorting.field &&
  sorting.field != "cargo" &&
  sorting.field != "abono" &&
  sorting.field != "saldo"
) {
  const reversed = sorting.order === "asc" ? 1 : -1;
  computedComments = computedComments.sort(
    (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
  );
}

if (
  sorting.field &&
  sorting.order === "asc" &&
  (sorting.field == "cargo" ||
    sorting.field == "abono" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
  );
}

if (
  sorting.field &&
  sorting.order === "desc" &&
  (sorting.field == "cargo" ||
  sorting.field == "abono" ||
    sorting.field == "saldo")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
  );
}

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
  ]);

  let saldoParcialTabla = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_usuarios ? (
        <div className="card container col-sm-11">
          <Row>
            <Col md={8}>
               
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  // onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          
          <h3 align="center">Saldo Dinero</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
                      {/* Filtros Fechas */}
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                saldoParcialTabla = saldoParcialTabla - p.cargo + p.abono
                {
                  return (
                    <tr>
                      <td> {p.fecha}</td>
                      <td> {p.numero}</td>
                      <td> {p.movimiento}</td>
                      <td> {p.observaciones}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(p.cargo)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(p.abono)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, }).format(saldoParcialTabla)}</td>
                    </tr>
                  );
                }
              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td className="negrita" align="right">Totales</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalCargos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                <td className="negrita">{"$"+new Intl.NumberFormat("en-US").format(totalSaldo)}</td>
                <td></td>
              </tr> */}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default SaldoDinero;
